import { globalObject, isBrowser } from '@skbkontur/global-object';
import { getDOMRect } from "../../../lib/dom/getDOMRect";
export var getTopAlignment = function getTopAlignment(_ref) {
  var clientHeight = _ref.clientHeight,
      offsetY = _ref.offsetY,
      scrollY = _ref.scrollY,
      target = _ref.target;
  return clientHeight + offsetY - scrollY - getDOMRect(target).top;
};
export var getManualPosition = function getManualPosition(_ref2) {
  var menuPos = _ref2.menuPos,
      target = _ref2.target,
      offsetY = _ref2.offsetY,
      clientHeight = _ref2.clientHeight;

  if (!menuPos || !isBrowser(globalObject)) {
    return undefined;
  }

  if (menuPos === 'top') {
    return {
      top: null,
      bottom: getTopAlignment({
        clientHeight: clientHeight,
        offsetY: offsetY,
        scrollY: globalObject.scrollY,
        target: target
      })
    };
  }

  if (menuPos === 'bottom') {
    return {
      top: globalObject.scrollY + getDOMRect(target).top + target.clientHeight + offsetY
    };
  }
};